module.exports = "/assets/site/images/icon-arrow-left.png?04559beed83ab84c2e43b7cfc53f1e07";